export default {
  renewal_date_override:"Date de renouvellement personnalisée",
  membership_term_start:"Début de la période d’adhésion",
  joined_at:"Date d’adhésion",
  billingFrequency:"Fréquence de facturation",
  contractMonths:"Durée du contrat (mois, 1–120)",
  billingOptions:"Options de facturation",
  accountHelp:"Autoriser l’imputation des achats admissibles au compte responsable configuré.",
  duesHelp:"Inclure les cotisations dans la facturation récurrente. L’adhésion reste rattachée à ce membre.",
  initiationHelp:"Inclure une seule fois le droit d’entrée dans le cycle de facturation applicable.",

  accountCharging:"Imputation au compte autorisée",
  duesEnrolment:"Activer la facturation récurrente et ajouter les cotisations",
  initiationFee:"Inclure le droit d’entrée dans le cycle de facturation récurrente",
  feesHelp:"Les cotisations et droits d’entrée sont imputés au compte responsable. Désactiver l’imputation des achats facultatifs au compte n’annule pas la facturation des cotisations.",
  status_open:"Ouvert",
  status_paid:"Payé",
  status_partially_settled:"Partiellement réglé",
  status_partially_paid:"Partiellement payé",
  status_pending:"En attente",
  status_overdue:"En retard",
  status_void:"Annulé",
  status_refunded:"Remboursé",
  status_reversed:"Extourné",
  status_cancelled:"Annulé",
  status_posted:"Comptabilisé",
  status_invoiced:"Facturé",
  status_settled:"Réglé",
  status_written_off:"Passé en perte",
  status_unknown:"Statut indisponible",

  billing_option_invalid:"Les options de facturation doivent être activées ou désactivées.",
  billing_payer_invalid:"Sélectionnez un membre valide comme payeur du compte.",
  "category": "Catégorie de membre",
  "adult": "Adulte",
  "child": "Enfant",
  "unclassified": "Non classé (ancien)",
  "requirePayer": "Exiger un autre membre comme payeur du compte",
  "thisMember": "Ce membre",
  "anotherMember": "Un autre membre",
  "accountPayer": "Payeur du compte",
  "search": "Rechercher par nom ou numéro de membre",
  "summary": "Les frais admissibles de {member} seront facturés au compte de {payer}.",
  "billedTo": "Facturé à {payer}",
  "forMember": "Pour {member}",
  "chargeAccount": "Débiter le compte de {payer} · Pour {member}",
  "linkedCharges": "Frais facturés à un autre membre",
  "searching": "Recherche de membres…",
  "typeToSearch": "Saisissez au moins 2 caractères pour rechercher.",
  "noResults": "Aucun membre trouvé.",
  "billing_forbidden": "Une autorisation est nécessaire pour modifier le responsable de la facturation.",
  "billing_member_not_found": "Le membre ou le payeur n’appartient pas à ce club.",
  "billing_member_inactive": "Le membre bénéficiaire du service est inactif.",
  "billing_account_charging_disabled": "L’imputation au compte est désactivée pour ce membre. Choisissez un paiement en espèces ou par carte, ou demandez au personnel de l’activer.",
  "billing_another_payer_required": "Ce type d’adhésion exige un autre payeur du compte. Sélectionnez un membre admissible.",
  "billing_payer_required": "Sélectionnez un payeur admissible avant d’activer la facturation au compte.",
  "billing_override_forbidden": "Vous ne pouvez pas remplacer le payeur configuré.",
  "billing_payer_inactive": "Le payeur est inactif. Sélectionnez un autre payeur admissible.",
  "billing_payer_chain": "Un payeur doit utiliser son propre compte et ne peut pas transférer les frais à un autre membre.",
  "billing_payer_ineligible": "Le payeur doit disposer d’un compte admissible avec l’imputation au compte activée.",
  "billing_account_ineligible": "Le compte responsable est absent ou inactif. Demandez au personnel de configurer un compte admissible.",
  "billing_credit_limit": "Ces frais dépassent la limite de crédit du compte responsable. Choisissez un paiement en espèces ou par carte, ou contactez le personnel.",
  "billing_mode_invalid": "Choisissez Ce membre ou Un autre membre.",
  "billing_payer_self": "Choisissez Ce membre pour utiliser votre propre compte.",
  "billing_policy_changed": "Les paramètres de facturation ont changé. Rechargez le membre avant d’enregistrer.",
  "billing_category_required": "Sélectionnez Adulte ou Enfant pour un nouveau type d’adhésion.",
  "billing_category_invalid": "Sélectionnez une catégorie de membre valide.",
  "billing_requirement_invalid": "Sélectionnez une exigence de payeur valide."
};
